import React, { useState } from 'react'
import { Popover, Typography, Box } from '@mui/material'
import { InfoOutlineIcon } from '@src/assets/icons/utils'
import { LxIcon } from '@src/components/icon/Icon'

const LogDetailsPopover = ({ details }: { details: string }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  // Parse and filter out null & empty values
  let parsedDetails: Record<string, any> = {}
  try {
    const data = JSON.parse(details)
    if (typeof data === 'object' && data !== null) {
      parsedDetails = Object.fromEntries(
        Object.entries(data).filter(([_, value]) => value !== null && value !== '') // Remove null & empty values
      )
    }
  } catch (error) {
    parsedDetails = { error: 'Invalid JSON format' }
  }

  const renderValue = (value: any, indent: number = 0) => {
    if (Array.isArray(value)) {
      return (
        <Box sx={{ pl: indent + 2, mt: 1 }}>
          {value.map((item, index) => (
            <div key={index}>{renderValue(item, indent + 2)}</div>
          ))}
        </Box>
      )
    }

    if (typeof value === 'object' && value !== null) {
      return (
        <Box sx={{ pl: indent + 2, mt: 1 }}>
          {Object.entries(value).map(([k, v]) => (
            <div key={k}>
              <Typography sx={{ fontSize: '12px', fontFamily: 'monospace' }}>
                <strong>{k}:</strong>
              </Typography>
              {renderValue(v, indent + 2)}
            </div>
          ))}
        </Box>
      )
    }

    return (
      <Typography sx={{ fontSize: '12px', fontFamily: 'monospace', pl: indent }}>
        {String(value)}
      </Typography>
    )
  }

  return (
    <>
      {/* Icon that triggers popover on click */}
      <div onClick={handleClick} style={{ display: 'inline-block', cursor: 'pointer' }}>
        <LxIcon icon={InfoOutlineIcon} />
      </div>

      {/* Popover for displaying formatted key-value details */}
      <Popover
        id="log-details-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <Box sx={{ p: 2, minWidth: 200 }}>
          {Object.keys(parsedDetails).length > 0 ? (
            Object.entries(parsedDetails).map(([key, value]) => (
              <div key={key}>
                <Typography sx={{ fontSize: '12px', fontFamily: 'monospace' }}>
                  <strong>{key}:</strong>
                </Typography>
                {renderValue(value, 2)}
              </div>
            ))
          ) : (
            <Typography sx={{ fontSize: '12px', fontFamily: 'monospace' }}>
              No Details to show
            </Typography>
          )}
        </Box>
      </Popover>
    </>
  )
}

export default LogDetailsPopover
